module.exports = __webpack_public_path__ + "img/lus.0bfa89c9.jpg";